import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import ImgUpsellHero from 'assets/emailMarketing/upsell-hero.svg';
import ImgUpsellAutomated from 'assets/emailMarketing/upsell-automated.svg';
import ImgUpsellRepeatCustomers from 'assets/emailMarketing/upsell-repeat-customers.svg';
import ImgUpsellRevenue from 'assets/emailMarketing/upsell-revenue.svg';
import {OPEN_CONTACT_FORM_MODAL} from 'store/emailMarketing/action';
import sendGtmEvent from 'helpers/services/utils/gtm';
import {
  UpsellButton,
  UpsellCard,
  UpsellCardImage,
  UpsellCardText,
  UpsellCardTitle,
  UpsellCards,
  UpsellFootnote,
  UpsellHero,
  UpsellHeroBody,
  UpsellHeroImage,
  UpsellHeroLabel,
  UpsellHeroText,
  UpsellHeroTitle,
  UpsellSectionTitle
} from 'routes/App/emailMarketingV2/components/UpsellPage/styles';

const FEATURES = [
  {
    image: ImgUpsellAutomated,
    title: 'Fully Automated',
    text:
      'Set it and forget it. Welcome series, cart recovery, and win-back emails run on autopilot — no manual work needed.'
  },
  {
    image: ImgUpsellRepeatCustomers,
    title: 'More Repeat Customers',
    text:
      'Stay top of mind with personalized emails that drive repeat orders and keep customers coming back regularly.'
  },
  {
    image: ImgUpsellRevenue,
    title: 'Revenue on Autopilot',
    text:
      'Every campaign is designed around how restaurant customers actually order — timing, frequency, and offers that work.'
  }
];

const UpsellPage = () => {
  const dispatch = useDispatch();
  const {activeLocation} = useSelector((state) => state.user);

  const onGetStarted = () => {
    dispatch(OPEN_CONTACT_FORM_MODAL(true));
    sendGtmEvent('click-marketing-start', {
      location_name: activeLocation?.FullName,
      location_id: activeLocation?._id
    });
  };

  return (
    <>
      <UpsellHero>
        <UpsellHeroText>
          <UpsellHeroLabel>Email Marketing</UpsellHeroLabel>
          <UpsellHeroTitle>
            Let Your Emails Bring Customers Back
          </UpsellHeroTitle>
          <UpsellHeroBody>
            Boost revenue by up to 40%* with automated email campaigns that
            bring customers back. Sauce handles everything — from welcome emails
            to win-back campaigns — so you can focus on cooking.
          </UpsellHeroBody>
          <UpsellButton onClick={onGetStarted} className='solid'>
            <span>Get Started</span>
          </UpsellButton>
        </UpsellHeroText>
        <UpsellHeroImage src={ImgUpsellHero} alt='' />
      </UpsellHero>

      <UpsellSectionTitle>Why Email Marketing?</UpsellSectionTitle>
      <UpsellCards>
        {FEATURES.map((feature) => (
          <UpsellCard key={feature.title}>
            <UpsellCardTitle>{feature.title}</UpsellCardTitle>
            <UpsellCardText>{feature.text}</UpsellCardText>
            <UpsellCardImage src={feature.image} alt='' />
          </UpsellCard>
        ))}
      </UpsellCards>

      <UpsellFootnote>
        * Based on data from active Sauce email marketing locations.
      </UpsellFootnote>
    </>
  );
};

export default UpsellPage;
